import './rxjs-extensions';

import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ReactiveformComponent } from './reactiveform.component';
import { ReactiveformRoutingModule } from './reactiveform.routing.module';
import { ValidatorService } from '../../services/validator/validator.service';
import { ErrorModule } from '../error/error.module';
import { SpinnerModule } from '../spinner/spinner.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveformRoutingModule,
    ReactiveFormsModule,
    ErrorModule,
    SpinnerModule
  ],
  exports: [
    ReactiveformComponent
  ],
  declarations: [
    ReactiveformComponent
  ],
  providers: [
    ValidatorService
  ]
})
export class ReactiveformModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ReactiveformModule
    };
  }
}
